export const contactCategories = {
  INDIVIDUAL_CATEGORY: "individual",
  ORGANIZATION_CATEGORY: "organization"
};

export const CLAIMS_DEPARTMENT_ID = "Claims";
